const mutations = {
  'SET_BUSINESS_FOLDERS' (state, { businessFolders }) {
    state.businessFolders = businessFolders;
  },
  'SET_BUSINESS_FOLDER' (state, { businessFolder }) {
    state.businessFolder = businessFolder
  }
}

export default mutations